import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { TableColumn } from '../../dto/util/table-column';
import {
  CorreoEntidadDTO,
  CorreoTablaDTO,
  MetricaEntidadDto,
  RespuestaCorreoDTO,
} from '../../dto/metrica-entidad/metrica-entidad.dto';
import { MetricaEntidadService } from '../../services/metrica-entidad.service';
import { AlertaModalService } from '../../services/util/alerta-modal.service';
import { TableAction } from '../../dto/util/table-action';
import { ModalService } from '../../services/util/modal.service';
import { FormField } from '../../dto/util/form-field';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
var $: any;
@Component({
  selector: 'app-metricas-entidad',
  templateUrl: './metricas-entidad.component.html',
  styleUrls: ['./metricas-entidad.component.scss'],
})
export class MetricasEntidadComponent implements OnInit {
  @ViewChild('modalCorreos') modalCorreos!: ElementRef;

  metricas: MetricaEntidadDto[] = [];
  columnas: TableColumn[] = [];
  acciones: TableAction[] = [];
  correos: CorreoEntidadDTO[] = [];
  campoCorreo: FormField[] = [];
  detalleCorreo!: CorreoTablaDTO;
  correo = '';
  correoValido = false;
  operadores = [
    { simbolo: '>', texto: 'Mayor que' },
    { simbolo: '<', texto: 'Menor que' },
    { simbolo: '=', texto: 'Igual a' },
  ];
  estados = [
    { simbolo: true, texto: 'Activo' },
    { simbolo: false, texto: 'Inactivo' },
  ];
  Id_Entidad?: number;

  formCorreo!: FormGroup;
  showModal = false;
  // Multilenguaje
  tableText: any = {};
  constructor(
    private metricaEntidadService: MetricaEntidadService,
    // Add this line
    private alertaModalService: AlertaModalService,
    private modalService: ModalService,
    private translate: TranslateService,
    private readonly fb: FormBuilder
  ) {}

  ngOnInit(): void {
    // Multilenguaje
    this.translate.stream('metricas').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this.inicializarColumnas();
      this.buildForm();
    });
    const userSessionData = sessionStorage.getItem('user_information_session');
    if (userSessionData) {
      try {
        const dataRol = JSON.parse(sessionStorage.getItem('user_type') ?? '{}');
        this.Id_Entidad = dataRol?.Id_Entidad;
      } catch (error) {
      }
    }
    this.metricaEntidadService
      .obtenerMetricasConEntidad(this.Id_Entidad)
      .subscribe(response => {
        if (!this.Id_Entidad) {
          this.metricas = response.map(metrica => {
            metrica.nombreMetrica = `${metrica.nombreMetrica} - ${metrica.entidad ?? Constants.acumulado_metrica}`;
            return metrica;
          });
        } else {
          this.metricas = response;
        }
      });

    this.formCorreo = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
      ],
    });
  }

  private inicializarColumnas() {
    this.columnas = [
      {
        field: 'nombreMetrica',
        title: this.tableText['metrica'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '18rem',
      },
      {
        field: 'operador',
        title: this.tableText['operador'],
        type: 'inputselect',
        enabledAction: 'true',
        filterable: false,
        sortable: false,
        width: '10rem',
        accion: item => {
          this.enviarCambios(item);
        },
        elements: this.operadores,
        option: 'texto',
        value: 'simbolo',
      },
      {
        field: 'valor',
        title: this.tableText['valor'],
        type: 'input',
        filterable: false,
        sortable: false,
        width: '8rem',
        inputType: 'number',
        accion: item => {
          if (item.valor < 0) {
            this.alertaModalService.error(this.tableText['valor-negativo'], '');
          } else if (!/^\d+$/.test(item.valor.toString())) {
            this.alertaModalService.error(this.tableText['error-numero'], '');
          } else {
            this.enviarCambios(item);
          }
        },
        elements: this.estados,
        option: 'number',
        value: 'simbolo',
        validations: {
          min: 1,
        },
      },

      {
        field: 'estado',
        title: this.tableText['estado'],
        type: 'inputselect',
        filterable: false,
        enabledAction: 'true',
        sortable: false,
        width: '10rem',
        accion: item => {
          this.enviarCambios(item);
        },
        elements: this.estados,
        option: 'texto',
        value: 'simbolo',
      },
    ];
    // Columna de acciones
    this.acciones = [
      {
        type: 'button',
        icon: 'edit',
        title: this.tableText['configurar-correo'],
        idAccion: '1',
      },
    ];
  }

  buildForm() {
    // Formulario correo
    this.campoCorreo = [
      {
        name: 'email',
        label: this.tableText['ingrese-correo'],
        type: 'email',
        required: true,
        validation: [Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)],
        errorMessages: {
          required: this.tableText['correo-required'],
          pattern: this.tableText['email-pattern'],
        },
      },
    ];
  }
  enviarCambios(item: any) {
    const userSessionData = sessionStorage.getItem('user_information_session');

    let correoElectronico = '';
    let Id_Entidad = null;

    if (userSessionData) {
      try {
        const userInformation = JSON.parse(userSessionData);

        correoElectronico = userInformation.correoElectronico;
        Id_Entidad = userInformation.tipoUsuario.Id_Entidad;
      } catch (error) {
        console.error('Error parsing sessionStorage data:', error);
      }
    } else {
      console.warn('No user information found in session storage.');
    }
    const payload = {
      metrica: item.nombreMetrica,
      operador: item.operador,
      umbral: Number(item.valor),
      estado: item.simbolo,
      correoElectronico: correoElectronico,
      Id_Entidad: Id_Entidad,
    } as MetricaEntidadDto;

    this.metricaEntidadService
      .modificarMetricasConEntidad(Number(item.Id), payload)
      .subscribe(
        response => {
        },
        error => {
        }
      );
  }

  // Función que consume el servicio de listar los correos asociados
  verCorreos(event: any) {
    this.showModal = true;
    this.detalleCorreo = event;
    setTimeout(() => {
      this.modalCorreos.nativeElement.click();
      this.listarCorreos(event);
    }, 500);
  }

  // Función que consume el servicio de listar correos
  listarCorreos(event: any) {
    this.metricaEntidadService
      .consultarCorreos(event.item.Id)
      .subscribe((resp: CorreoEntidadDTO[]) => {
        this.correos = resp;
      });
  }
  // Función que consume el servicio de eliminar el correo seleccionado
  eliminar(correo: CorreoEntidadDTO) {
    this.metricaEntidadService
      .eliminarCorreo(correo.id)
      .subscribe((resp: RespuestaCorreoDTO) => {
        if (resp.success) {
          this.listarCorreos(this.detalleCorreo);
        } else {
          this.alertaModalService.error(resp.message);
        }
      });
  }

  agregar() {
    const json: CorreoEntidadDTO = {
      id: null,
      idMetricaEntidad: this.detalleCorreo.item.Id,
      correoElectronico: this.correo,
    };

    // Validar si el correo ya existe en la lista
    const correoExiste = this.correos.some(
      c => c.correoElectronico === this.correo
    );
    if (correoExiste) {
      this.alertaModalService.error('¡El correo ya está en la lista!');
      return;
    }

    if (this.correos.length >= 10) {
      this.alertaModalService.error('¡Ya se han agregado 10 correos!');
      return;
    } else {
      this.metricaEntidadService
        .agregarCorreo(json)
        .subscribe((resp: RespuestaCorreoDTO) => {
          if (resp.success) {
            this.listarCorreos(this.detalleCorreo);
            this.formCorreo.reset();
          } else {
            this.alertaModalService.error(resp.message);
          }
        });
    }
  }

  onSubmit(event: FormGroup) {
    if (event?.controls?.['email']) {
      this.formCorreo = event;
      this.correo = event.controls['email'].value;
      this.correoValido = event.valid;
    } else {
      this.correoValido = false;
    }
  }
}
